export const semanticVariants = {
  display: ['body24sb', 'body28sb', 'body28sb'],
  subject: ['body20sb', 'body24b', 'body24b'],
  title: ['body18sb', 'body20sb', 'body20sb'],
  lead: ['body16sb', 'body18sb', 'body18sb'],
  subtitle: ['body16sb', 'body16sb', 'body16sb'],
  body: ['body14n', 'body14n', 'body14n'],
  emphasis: ['body14sb', 'body14sb', 'body14sb'],
  label: ['body14m', 'body14m', 'body14m'],
  caption: ['body12n', 'body14n', 'body14n'],
  meta: ['body10n', 'body12n', 'body12n'],
}

export const semanticVariantKeys = Object.keys(semanticVariants)

export const resolveSemanticVariant = (variant) => {
  if (typeof variant === 'string' && semanticVariants[variant]) {
    return semanticVariants[variant]
  }
  return variant
}
